import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Login from './components/Login.js';
import Home from './components/home';
import About from './components/about';
import Create from './components/create';
import Header from './components/NavBar'; // Renamed from NavBar to Header
import Edit from './components/edit';
import Delete from './components/delete';
import Marketing from './components/marketing';
import ProductSearch from './components/product_search.js';
import ProductDetailPage from './components/product_details.js';
import BrandDetailPage from './components/brand_details.js';
import OrderSearchPage from './components/order_search.js';
import PriceListCatalogPage from './components/price_list.js';
import CatalogsPage from './components/catalogs.js';
import QuotationsListPage from './components/quotations_list.js';
import QuotationDetailPage from './components/quotation_detail.js';
import SetupAccount from './components/setup_account.js';
import NotFound from './components/404_page.js'
import ProtectedRoute from './components/ProtectedRoute';
import ForgotPassword from './components/forgot_password_page.js';
import MyAccount from './components/my_account.js';
import AIAssistant from './components/ai_assistant.js';
import ChatWidget from './components/ChatWidget.js';

function App() {
  const location = useLocation(); // Get current route

  // Check if current path exactly matches login OR starts with setup path
  const shouldShowHeader = !(
    location.pathname === '/' ||
    location.pathname.startsWith('/users/setup') ||
    location.pathname.startsWith('/forgot-password')
  );

  // AI access — read from localStorage (set at login). Default true if not yet set.
  const aiAccess = localStorage.getItem('ai_access') !== 'false';

  return (
    <div className="App">
      {/* Show Header only if not on Login or Setup Account pages */}
      {shouldShowHeader && <Header />}
      
      <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/about"
        element={
          <ProtectedRoute>
            <About />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create"
        element={
          <ProtectedRoute>
            <Create />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit/:id"
        element={
          <ProtectedRoute>
            <Edit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/delete/:id"
        element={
          <ProtectedRoute>
            <Delete />
          </ProtectedRoute>
        }
      />
      <Route
        path="/marketing"
        element={
          <ProtectedRoute>
            <Marketing />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/list"
        element={
          <ProtectedRoute>
            <ProductSearch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/product/:productId"
        element={
          <ProtectedRoute>
            <ProductDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/brand/:id"
        element={
          <ProtectedRoute>
            <BrandDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <OrderSearchPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalogs"
        element={
          <ProtectedRoute>
            <CatalogsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalogs/:category"
        element={
          <ProtectedRoute>
            <PriceListCatalogPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quotations"
        element={
          <ProtectedRoute>
            <QuotationsListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quotations/:quotationId"
        element={
          <ProtectedRoute>
            <QuotationDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-account"
        element={
          <ProtectedRoute>
            <MyAccount />
          </ProtectedRoute>
        }
      />
      {aiAccess && (
        <Route
          path="/ai-assistant"
          element={
            <ProtectedRoute>
              <AIAssistant />
            </ProtectedRoute>
          }
        />
      )}
      <Route path="/users/setup/:uidb64/:token" element={<SetupAccount />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    {shouldShowHeader && location.pathname !== '/ai-assistant' && aiAccess && <ChatWidget />}
    </div>
  );
}

export default App;